export class RogueCase {
  id: number;
  case_type: string;
  case_type_display: string;
  case_justification: string;
  case_owner: string;
  case_assigned_to: string;
  case_assigned_to_display: string;
  case_create_date: Date;
  case_create_timestamp: Date;
  rogue_removal_isn: number;
  cpn: string;
  mpn: string;
  msn: string;
  noun: string;
  description: string;
  acn: string;
  pos: string;
  fleet_cd: string;
  removal_dt: Date;
  tsi: number;
  cum_avg_tsi_by_mpn_at_remv: number;
  removal_reason_cd: string;
  rogue_avg_tsi: number;
  m2_count: number;
  sig_event_ind_sum: number;
  sig_event_sum: number;
  so_cost_sum: number;
  so_cost_avg: number;
  m2_cost_sum: number;
  m2_cost_avg: number;
  atb_cost_sum: number;
  atb_cost_avg: number;
  div_cost_sum: number;
  div_cost_avg: number;
  rto_cost_sum: number;
  rto_cost_avg: number;
  ifsd_cost_sum: number;
  ifsd_cost_avg: number;
  pain_value_sum: number;
  pain_value_avg: number;
  removal_isn_1: number;
  removal_isn_2: number;
  removal_isn_3: number;
  tracker_action: string;
  WB_CASE_NBR: number;
  pre_meeting_recommendation: string;
  post_meeting_recommendation: string;
  meeting_date: Date;
  meeting_timestamp: Date;
  recommendation_accomplished: number;
  accomplishment_valid: number;
  notes: string;
  uploadedFiles: string[];
  active_unit_ind: number;
  tracker_action_secondary: string;
  fsc: string;
  current_status: string;
  current_locn: string;
  current_dept: string;
  current_pos: string;
  post_meeting_recommendation_filled: string;
  tracker_action_filled: string;
  currently_pending_user: string;
  currently_pending_action: string;
  currently_pending_update_timestamp: Date;
  currently_pending_status: string;
  removal_order_nbr: string;
  removal_order_tag_nbr: string;
  removal_order_claim_nbr: string;
  fsc_vendor_name: string;
}
